import React,{useState, useEffect} from "react";

import { Link, useNavigate } from 'react-router-dom'
import axios from "axios";
import { countyurl } from "../../../apis/urls";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddCounty = () => {

    const [name,setName] = useState('');
    const [description,setDescription] = useState('');
    const [status,setStatus] = useState('');
    const [nameerror,setNameerror] = useState(false);
    const[alertText, setAlertText]=useState("");
    const[added, setAdded]=useState(false);


    useEffect(() => {

        if(added == true){

            const notify = () => toast.success("Created Successfully!..", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 800
              });

              notify();
        }
      }, [added])


    let navigate = useNavigate();
    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/county_list")
        
    }


    const onFormClick = () => {

        

        let error = 0;

        if(name == '')
        {
            setNameerror(true);
            error=1;

        }

        if(error === 0)
        {

            let token = "Bearer "+localStorage.getItem('token');
            console.log(token)
            const data = {
                name :name,
                description :description,
                status :'ACTIVE'
            }
            
            const instance = axios.create({

                baseURL: countyurl,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.post('',data).then((response) =>{

                setAdded(true);
                
                let path = 'newPath'; 

                setTimeout(() => {

                    navigate("/county_list")

                }, 800);

                setAlertText("County Created");
            
            }).catch((error) =>{
                
                console.log('error',error)

                //setNameerror('Enter the Name')
                

            });

        }

        



    }

    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Add New County</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/county_list">County</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Add County</li>
                        </ol>
                    </nav>

                    <form className="needs-validation" noValidate>
                    <div className="form-wrpr">
                        <div className="card formcard small">
                            <div className="card-body">
                                <div className="form-group">
                                    <label className="degreehead">Name <span style={{color: "red"}}>*</span></label>
                                    <input type="text" className="form-control bg-dark dark-theme showtext" value={name} onChange={e => {setName(e.target.value)}} placeholder="Enter County" id="name"></input>
                                    {
                                       nameerror
                                       ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Name</div>
                                       :null
                                    }
                                    
                                </div>
                                <div className="form-group">
                                    <label className="degreehead">Description</label>
                                    <input type="text" className="form-control bg-dark dark-theme showtext" value={description} onChange={e => {setDescription(e.target.value)}} placeholder="Enter the Description" id="name"></input>
                                </div>
                                {/* <div className="form-group">
                                    <label className="degreehead">Status <span style={{color: "red"}}>*</span></label>
                                        <select  value={status} onChange={e => {setStatus(e.target.value)}} type="password" class="form-control bg-dark" id="state">
                                                <option >Select Status</option>
                                                <option>ACTIVE</option>
                                                <option>INACTIVE</option>
                                                <option>DELETED</option>
                                            
                                        </select>
                                </div> */}
                                <h6 style={{color: "red"}}>* Required Fields</h6>
                                
                                <div className="form-group text-right">
                                    <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                    <button onClick={onFormClick} className="btn btn-primary btn-gisa" type="button">Create</button>
                                </div>
                                <div>
                                    {/* <button onClick={notify}>Notify !</button> */}
                                    <ToastContainer
                                        style={{width: 578, marginTop: '10%', marginLeft: '8.3%'}}
                                        toastStyle={{backgroundColor: "#07bc0c", color: 'white', fontSize: 16}}
                                        progressStyle={{backgroundColor: 'white'}}
                                        
                                    />
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </form>


                </div>
            </aside>
        </div>
    )
}

export default AddCounty;